import React from 'react';
import EditUserInfoForm from './EditUserInfoForm';

const index = () => {
    return <EditUserInfoForm />;
};

export default index;
